import React from 'react';
import { Button } from "antd";

class Body extends React.Component {
  constructor(props){
    super(props);
    this.state = {

    }
  }
  toOverview = () =>{
    window.location.href = "#/overview";
  }
  render(){
    const error = this.props.menu;
    return (
      <div id="errorMain">
        {
          error === "/404" &&
          <div id="errorDesc">
            <div className="error-image 404">
              <img src="images/404.png" alt="" width="100%"/>
            </div>
            <div className="error-desc">
              <div className="error-code">404</div>
              <div className="error-text">抱歉，你访问的页面不存在</div>
              <div className="error-btn">
                <Button type="primary" onClick={ this.toOverview }>返回首页</Button>
              </div>
            </div>
          </div>
        }
        {
          error === "/500" &&
          <div id="errorDesc">
            <div className="error-image 500">
              <img src="images/500.png" alt="" width="100%"/>
            </div>
            <div className="error-desc">
              <div className="error-code ">500</div>
              <div className="error-text">抱歉，你访问的页面不存在</div>
              <div className="error-btn">
                <Button type="primary" onClick={ this.toOverview }>返回首页</Button>
              </div>
            </div>
          </div>
        }
        {
          error === "/403" &&
          <div id="errorDesc">
            <div className="error-image 403">
              <img src="images/403.png" alt="" width="100%"/>
            </div>
            <div className="error-desc">
              <div className="error-code">403</div>
              <div className="error-text">抱歉，你访问的页面不存在</div>
              <div className="error-btn">
                <Button type="primary" onClick={ this.toOverview }>返回首页</Button>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Body;



// WEBPACK FOOTER //
// ./src/index/error.js